<template>
	<div>
		<!-- 左侧导航列表 -->
		<div class="bar_left" :class="{'isCollect': menucollect}">
			<!-- 1级导航 --> 
			<div class="barItems Flexalign" v-for="(item1,index1) in tablist" 
			:class="{'isActive':  item1.arrowShow || item1.isActive }"
				@mouseover="tabHover(item1, index1)" @mouseleave="tabeout(item1)">
				<!-- 栏目图标 --> 
				<div class="bar_icon FlexRow">
					<i class="iconfont " :style="item1.iconstyle" :class="item1.icon"></i>
				</div>
				<!-- 栏目名称 -->
				<transition name="el-fade-in-linear">
					<div class="bar_title" v-show="tit_show">
						{{item1.title}} 
					</div>
				</transition>
			</div>
			<!-- 展开/收起 按钮 -->
			<div class="foldbtn">
				<i class="foldicon" :class="iconFold" @click="handlemenuFold"></i>
			</div>
		</div>
		<!--  -->
		<!-- 左侧导航子项 弹出区域 -->
		<transition name="el-fade-in-linear"> 
		
			<div class="bar_alert" :style="alertStyle"
			v-show="alertShow" @mouseover="alerteHover" @mouseleave="alerteOut">
				<!-- 子项列表 -->
				<div class="son_area FlexWrap">
					<!-- 子项 2级导航 -->
					<div class="son_lv2"
					:class="{'noRight': (index1 + 1) % 5 == 0}"
						v-for="(item1, index1) in alertList">
						<div class="tit">
							{{item1.title}}
						</div>
						<!-- 子项 3级导航 -->
						<div class="lv2_child">
							<template v-if="item1.son">
								<!-- 有子项的区域 -->
								<div class="son_lv3 Flexalign" v-for="(item2, index2) in item1.son"
									:class="{'isActive': item2.isActive}" @click="lv3Click(item2)">
									<div class="tit2 FlexItem">
										{{item2.title}} 
									</div>
									<div class="icon">
										<i class="iconfont icon-a-lujing13"></i>
									</div>
								</div>
							</template>
							<template v-else>
								<!-- 无子项的区域 -->
								<div class="son_lv3 Flexalign" @click="lv3Click(item1)"
									:class="{'isActive': item1.isActive}">
									<div class="tit2 FlexItem">
										{{item1.title}}
									</div>
									<div class="icon">
										<i class="iconfont icon-a-lujing13"></i>
									</div>
									
								</div>
							</template>
						</div>
						<!-- 3 -->
					</div>
					<!-- 2 -->
				</div>
				<!--  -->
			</div>
		</transition>
		<!--  -->
	</div>
</template>

<script>
	import {External_navlist} from '../js/nav.js'
	import {getRandomInt} from '@/network/defaults.js'
	export default {
		data() {
			return {
				menucollect: false,
				tit_show: true,
				iconFold: 'el-icon-s-fold',
				tablist: [],
				alertList: [],
				alertShow: false,
				tOut_Timer: null,
				alert_Timer: null,
				alert_top: '60px',
				alert_left: '200px',
				alert_height: '', 
			}
		},
		computed: {
			alertStyle(){
				let str =  `left:${this.alert_left}; top:${this.alert_top};`
				if(this.alert_height) {
					// height: calc(100vh - ${this.alert_height});
					let h = `
					max-height: calc(100vh - ${this.alert_height});
					`
					str += h
				}
				return str
			},
		},
		created() {
			this.setTabs()
		},
		watch: {
			$route(to,from){
				this.setTabs()
			},
		},
		methods: {
			
			tabHover(item1, index1) {
				let t_val = 0
				this.alert_height = ''
				console.log('index1', index1)
				if(index1 == 7){
					t_val = (48 * 2) + 60
				}
				else {
					t_val = (48 * index1) + 60
				}
				if(index1 == 3 || index1 == 4) {
					this.alert_height = `${t_val + 50}px`
				}
				this.alert_top = `${t_val}px`
				// this.clearIsAct()
				this.clearArrows()
				clearTimeout(this.alert_Timer)
				
				this.alertShow = true
				let c_list = JSON.parse(JSON.stringify(item1.son)) || []
				if (!c_list.length) return
				for (let item1 of c_list) {
					this.setChilds(item1)
				}
				this.alertList = c_list
				// 
				
			},
			setTabs() {
				let tlist = this.$fn_retjson(External_navlist)
				for (let item1 of tlist) {
					item1.isActive = false
					this.setChilds(item1)
					if(item1.son){
						item1.isActive = item1.son.some(r=>{
							if(r.son) {
								return r.son.some(v=>v.isActive)
							}
							return r.isActive
						})
					}
					
				}
			
				this.tablist = tlist
			},
			setChilds(obj){
				let c_path = this.$route.path
				if (obj.son) {
					for (let item2 of obj.son) {
						this.setChilds(item2)
					}
				}
				else {
					if (obj.path == c_path) {
						obj.isActive = obj.newbuilt == 1 ? false : true
					}
				}
			},
			tabeout(item1) {
				this.tOut_Timer = setTimeout(() => {
					item1.arrowShow = false
					this.alertShow = false
					this.setTabs()
				}, 500)
			},
			alerteHover() {
				clearTimeout(this.tOut_Timer)
				clearTimeout(this.alert_Timer)
			},
			alerteOut() {
				this.alert_Timer = setTimeout(() => {
					this.clearArrows()
					this.alertShow = false
					this.setTabs()
				}, 500)
			},
			clearArrows() {
				clearTimeout(this.tOut_Timer)
				this.alertList = []
				for (let item of this.tablist) {
					item.arrowShow = false
				}
			},
			// 跳转页面
			lv3Click(item) {
				if (!item.path) return
				let data = {
					newbuilt: item.newbuilt
				} 
				let rn = getRandomInt(1, 9999)
				data[`param${rn}`] = rn
				let query = item.newbuilt ? data : {}
				if(!item.newbuilt && item.path == this.$route.path) return
				this.$router.replace({
					path: item.path,
					query,
				})
				this.alertShow = false
				this.clearArrows()
			},
			handlemenuFold() {
				this.menucollect = !this.menucollect
				this.tit_show = !this.tit_show 
				this.iconFold = this.menucollect ? 'el-icon-s-unfold' : 'el-icon-s-fold';
				this.alert_left = this.menucollect ? '68px' : '200px';
				
			},
			
		},
	
	};
</script>

<style scoped lang="scss">
	.foldbtn {
		height: 5%;
		.foldicon {
			cursor: pointer;
			position: absolute;
			bottom: 24px;
			font-size: 24px;
			right: 20px;
			// color: #4e5969;
			color: #b1b7c2;
			box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.4);
			&:hover{
				color: #fff;
			}
		}
	}
	.bar_left {
		
		transition: all .3s;
		width: 200px;
		padding: 0 10px;
		height: 100%;
		overflow-y: auto;
		overflow-x: hidden;
		background: #242e47;
		position: relative;
		color: #b1b7c2;
		// border-right: solid 1px ;
		.barItems {
			width: 100%;
			height: 40px;
			cursor: pointer;
			position: relative;
			// color: #2e405e;
			color: #b1b7c2;
			// border-radius: 6px;
			// border:solid 1px red;
			// margin-bottom: 12px;
			margin-top: 8px ;
			position: relative;
			border-radius: 2px;
			.bar_icon {
				width:48px;
				// max-width:48px;
			 //    width: 13px;
			 //    margin: 0 17px 0 13px;	
				i {
					color: inherit;
					font-size: 16px;
				
				}
			}
			.bar_title {
				font-size: 14px;
				font-weight: 550;
				color: inherit;
				text-align: left;
				vertical-align: top;
				white-space: nowrap;
			}
			&.isActive, &:hover {
				// background: #EDF4FF;
				// color: #1375FC;
				background: #1375FC;
				color: #ffffff;
				i {
					color: inherit;
				}
			}
			&.isActive::before, &:hover::before{
				// content:'';
				// display: block;
				// position: absolute;
				// left: 0;
				// top: 0;
				// height: 100%;
				// width: 4px;
				// background: #1375FC;
			}
			
		}
		&.isCollect {
			width: 68px;
		}
		&::-webkit-scrollbar {
			width: 0px;
		}
	}
	.bar_alert {
		overflow: hidden;
		position: absolute;
		// max-width: 980px;
		max-width: 780px;
		min-height: 160px;
			// border:solid 1px red;
		
		border-radius: 0 8px 8px 0;
		// background: var(--themeColors);
		background: #242e47;

		// box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
		top: 60px;
		
		z-index: 1000;
		
		
		box-shadow: 3px 2px 4px  rgba(0, 0, 0, 0.03),
					3px -2px 2px  rgba(0, 0, 0, 0.03);
		// box-shadow: rgba(0, 0, 0, 0.2) 0px 12px 28px 0px, rgba(0, 0, 0, 0.1) 0px 2px 4px 0px, rgba(255, 255, 255, 0.05) 0px 0px 0px 1px inset;

		.son_area {
			// border: solid 1px green;
			padding: 30px 0 20px 30px;
			// padding: 38px 0 20px 38px  ;
			width: 100%;
			// max-height: calc(100vh - 500px);
			height: 100%;
			overflow: auto;
			
			height: auto;
			    // flex-wrap: nowrap !important;
		}
	}
	.son_lv2 {
		width: 130px;
		margin-bottom: 20px;
		margin-right: 20px;
		// border:solid 1px red;
		.tit {
			font-weight: 550;
			
			text-align: left;
			vertical-align: top;
			white-space: nowrap;
			margin-bottom: 10px;
			padding: 0 0 12px 8px;
			line-height: 28px;
			color: #b1b7c2;
			border-bottom: solid 1px #3a3b50;
			font-size: 16px;
			// color: rgba(78, 89, 105, 1);
			text-align: left;
			vertical-align: top;

		}
		.lv2_child {
			width: 100%;
			.son_lv3 {
				white-space: nowrap;
				margin-top: 4px;
				width: 100%;
				border-radius: 3px;
				height: 35px;
				padding: 0 9px 0 8px;
			
			
				font-size: 14px;
				font-weight: 400;
				
				// color: rgba(78, 89, 105, 1);
				    color: #b1b7c2;
				text-align: left;
				vertical-align: top;
				&.isActive{
					// background:#EDF4FF;
					// color: #1375FC;
					    background: #1375FC;
					    color: #ffffff;
				}
				&:hover{
					    background: #1375FC;
					    color: #ffffff;
					.icon{
						display: block;
					}
				}
				.tit2 {
					cursor: pointer;
					font-size: 14px;
					font-weight: 400;
					color: inherit;
					text-align: left;
					vertical-align: top;
				}
				
				.icon{
					cursor: pointer;
					display: none;
					i{
						font-size: 12px;
						// color: rgba(78, 89, 105, 1);
						color: #fff;
					}
				}
			}
		}
	}
</style>